import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Label } from 'reactstrap';
import { Box, Grid } from '@material-ui/core';
import Form from '../form/components/Form';
import SubmitButton from '../form/components/SubmitButton';
import { IdPropType, RefPropType } from '../../proptypes/basic';
import { storeLocationAgency, updateLocationAgency } from './locationAgenciesSlice';
import { LOCATION_AGENCY_RESOURCE } from '../api/resources';
import { useInitialValues } from '../form/hooks';
import { useCanWrite } from '../abilities/hooks';
import { selectAgencyById } from '../agencies/agenciesSlice';
import { selectLocationById } from '../locations/locationsSlice';
import TextInput from '../form/components/TextInput'; 
import LoadingBox from '../loading/components/LoadingBox';

const LocationAgencyForm = ({ locationId, agencyId, onDone, submitRef }) => {
    const dispatch = useDispatch();
    const agency = useSelector((state) => selectAgencyById(state, agencyId));
    const location = useSelector((state) => selectLocationById(state, locationId));
    const canWrite = useCanWrite(LOCATION_AGENCY_RESOURCE);
    const loading = !agency || !location;
    const locationAgency = useMemo(() => agency?.locationAgencies.find(la => String(la.locationId) === String(locationId)), [agency, locationId]);

    const initialValues = useInitialValues(locationAgency, {
        id: (locationAgency && locationAgency.id) || null,
        locationId: (locationAgency && locationAgency?.locationId) || locationId,
        agencyId: (locationAgency && locationAgency?.agencyId) || agencyId,
        agencyDatevId: (locationAgency && locationAgency?.agencyDatevId) || '',
    });

    const handleSubmit = (values) => {
        const prepped = {
            id: locationAgency?.id,
            locationId: (locationAgency && locationAgency?.locationId) || locationId,
            agencyId: (locationAgency && locationAgency?.agencyId) || agencyId,
            ...values,
        };
        const action = locationAgency ? updateLocationAgency(prepped) : storeLocationAgency(prepped);
        return dispatch(action).then(onDone);
    };

    return (
        <LoadingBox loading={loading}>
            <Form
                initialValues={initialValues}
                enableReinitialize
                onSubmit={handleSubmit}
                subject={locationAgency || LOCATION_AGENCY_RESOURCE}
            >
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Label>Agentur: {agency?.name}</Label>
                            </Grid>
                            <Grid item xs={12}>
                                <Label>Standort: {location?.name}</Label>
                            </Grid>
                            <Grid item xs={12}>
                                <TextInput
                                    label="Datev-Kundennummer"
                                    name="agencyDatevId"
                                    fullWidth
                                    disabled={!canWrite}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    {submitRef ? (
                        <SubmitButton container={submitRef} disabled={!canWrite} />
                    ) : (
                        <Grid item xs={12}>
                            <Box textAlign="right">
                                <SubmitButton />
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </Form>
        </LoadingBox>
    );
};

LocationAgencyForm.propTypes = {
    locationId: IdPropType.isRequired,
    agencyId: IdPropType.isRequired,
    onDone: PropTypes.func,
    submitRef: RefPropType,
};

LocationAgencyForm.defaultProps = {
    onDone: () => null,
    submitRef: null,
};

export default LocationAgencyForm;